module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navmenu"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.breadcrumbs), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.name,
      attrs: {
        "to": {
          path: item.path
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "navhead"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.icon),
      expression: "!!icon"
    }],
    staticClass: "navicon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ico_skill11.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navtitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pagetitle))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.introduction))])])]), _vm._v(" "), (_vm.$route.meta.navprops) ? _c('el-tabs', {
    staticClass: "ai-tabs--card",
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.$route.path),
      callback: function($$v) {
        _vm.$set(_vm.$route, "path", $$v)
      },
      expression: "$route.path"
    }
  }, _vm._l((_vm.$route.meta.navprops.paths), function(item) {
    return (!_vm.hideTabs || _vm.hideTabs.join('').indexOf(item.path) === -1) ? _c('el-tab-pane', {
      key: item.keypath,
      attrs: {
        "name": item.subpath && item.subpath.join('').indexOf(_vm.$route.path) > -1 || _vm.$route.path.indexOf(item.keypath) > -1 ? _vm.$route.path : item.path
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('i', {
      class: [(_vm.$route.path === item.path || (item.subpath && item.subpath.join('').indexOf(_vm.$route.path) > -1) || _vm.$route.path.indexOf(item.keypath) > -1) ? 'active' : '', item.icon, 'tabicon']
    }), _vm._v("\n        " + _vm._s(item.name) + "\n      ")])]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), (_vm.$route.meta.navprops) ? _c('img', {
    staticClass: "navi",
    attrs: {
      "src": _vm.$route.meta.navprops.iconurl,
      "alt": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66df24cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navmenu.vue
// module id = 520
// module chunks = 4